import { EActiveState } from 'constants/enums';
import { FormikErrors, FormikTouched, FormikValues } from 'formik';

export interface CheckoutDesign {
  externalTemplateId: string;
  templateId?: string;
  name: string;
  logo: string;
  buttonColor: string;
  buttonTextColor: string;
  primaryColor: string;
  textColor: string;
  backgroundImage?: string;
  mobileBgImage?: string;
  isActive: boolean;
  filterAPMs: boolean;
  filterWallets: string[];
  expandProductList: boolean;
}

export interface FormikProps {
  values: FormikValues;
  handleChange: (e?: any) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  touched: FormikTouched<CheckoutDesign>;
  errors: FormikErrors<CheckoutDesign>;
  setFieldValue: Function;
  isValid?: boolean;
  dirty?: boolean;
  submitForm?: () => void;
  validateField?: (field: string) => void;
}

export interface CheckoutDesignTabProps {
  formikProps: FormikProps;
}

export type CheckoutDesignFormProps = {
  edit?: boolean;
  dup?: boolean;
};

export enum ECheckoutDesignTabs {
  SETTINGS = 'Settings',
  CHECKOUT_DESIGN = 'Checkout Design',
  CHECKOUT_DISPLAY = 'Checkout Display'
}

export const tabTitles = [
  ECheckoutDesignTabs.SETTINGS,
  ECheckoutDesignTabs.CHECKOUT_DESIGN,
  ECheckoutDesignTabs.CHECKOUT_DISPLAY
];

export const WALLETS = [
  { key: 'apple', label: 'Apple' },
  { key: 'paypal', label: 'Paypal' },
  { key: 'google', label: 'Google Pay' }
];

export const PRODUCTS_PREVIEW_OPTIONS = [
  { value: 'Collapse', label: 'Collapse', id: 'option-collapse' },
  { value: 'Expand', label: 'Expand', id: 'option-expand' }
];

export const PREVIEW_MODE_OPTIONS = [
  { value: 'Visible', label: 'Visible', id: 'option-visible' },
  { value: 'Hidden', label: 'Hidden', id: 'option-hidden' }
];

export const STATUS_OPTIONS = [
  {
    value: EActiveState.ACTIVE,
    label: EActiveState.ACTIVE,
    id: 'option-isActive'
  },
  {
    value: EActiveState.INACTIVE,
    label: EActiveState.INACTIVE,
    id: 'option-inactive'
  }
];

export const DEFAULT_LOGO =
  'https://media.appcharge.com/defaults/default-store-logo.svg';
